////////////////////////////////////////////////////////////////////////////////
// Case Studies
////////////////////////////////////////////////////////////////////////////////

class CaseStudies extends News {

	constructor(entry) {
		super(entry, 'case-studies')
	}

}
